/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".back-link[_ngcontent-%COMP%]{color:#d4002d;text-decoration:underline;background-color:#e9f4fa;display:block;padding:10px 10px 10px 30px;margin-left:-15px;margin-right:-15px;margin-top:-7px;font-weight:600}.race-voided[_ngcontent-%COMP%]{text-decoration:line-through}h2[_ngcontent-%COMP%]{color:#000}h4[_ngcontent-%COMP%]{color:#002f71}"];
export { styles as styles };
